
    export default 
    {
    "ad_1688": {
        "top_banner": "¡El Programa de Proveedores Masivos de Dsers está en marcha! Apoyado por el equipo de proveedores de AliExpress, 1688 y Dsers. Obtén entre un 10% y un 30% de descuento en los productos.",
        "learn_more": "Más información"
    }
}